module.exports = __webpack_public_path__ + "img/button.a183cec4.png";